import { SearchConditionsParams, SearchConditionsResponse } from "@/component/FilterCommon/hooks/useSearchCondition";
import { httpMobile } from "@/utils/httpMobile";




export const serviceSearchConditions =  async <T extends SearchConditionsParams>(params: T,) => {
  let res =  await httpMobile.post<AxiosHttpPromise<SearchConditionsResponse<T>>>('/api.php',{
    a:'searchConditions',
    // val:JSON.stringify({skey:'b727bfe64bbb44101a0ded02be03e8af'}),
    c:'Base',
    ...params,
  })
  return res
};